import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export default function Logo({ variant = "default", className }) {
  return (
    <div className={cn("flex items-center gap-3 select-none", className)}>
      {/* The Animated Symbol */}
      <div className="relative flex items-center justify-center w-8 h-8">
        
        {/* Core Node (The Self) - Always breathes */}
        <motion.div 
          className="w-3 h-3 bg-[var(--nily-teal)] rounded-full shadow-[0_0_15px_var(--nily-teal)] relative z-10"
          animate={{ scale: [1, 1.3, 1], opacity: [0.8, 1, 0.8] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Variant: Corporate (The System Orbit) */}
        {variant === "corporate" && (
          <motion.div 
            className="absolute inset-0 rounded-full border border-[var(--nily-teal)]/30 border-t-transparent"
            animate={{ rotate: 360 }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          />
        )}

        {/* Variant: Clinical (The Precision Grid) */}
        {variant === "clinical" && (
          <>
            <div className="absolute w-full h-[1px] bg-[var(--neurova-purple)]/40" />
            <div className="absolute h-full w-[1px] bg-[var(--neurova-purple)]/40" />
            <div className="absolute inset-0 border border-[var(--neurova-purple)]/20 rounded-sm scale-75" />
          </>
        )}
        
        {/* Base Glow Layer */}
        <div className="absolute inset-0 bg-[var(--nily-teal)]/20 blur-md rounded-full" />
      </div>

      {/* Typography */}
      <div className="flex flex-col leading-none justify-center">
        <span className="text-xl font-heading font-bold text-[var(--text-main)] tracking-tight">
          Nily<span className="text-slate-500 font-sans font-normal text-base ml-0.5">.OS</span>
        </span>
      </div>
    </div>
  );
}
